var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgC(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 512 512",
    enableBackground: "new 0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "5151e0c8492e5103c096af88a51e4352"
  }, /*#__PURE__*/React.createElement("path", {
    display: "inline",
    d: "M362.517,300.83l133.815,40.447c-8.992,37.531-23.146,68.881-42.471,94.047 c-19.323,25.158-43.314,44.154-71.964,56.963c-28.653,12.811-65.11,19.215-109.385,19.215c-53.705,0-97.578-7.809-131.62-23.418 c-34.047-15.605-63.431-43.049-88.148-82.354c-24.716-39.295-37.077-89.604-37.077-150.915c0-81.738,21.744-144.556,65.226-188.466 C124.37,22.454,185.888,0.499,265.44,0.499c62.247,0,111.174,12.59,146.791,37.753c35.622,25.165,62.075,63.822,79.386,115.949 l-134.832,30c-4.72-15.049-9.664-26.064-14.828-33.03c-8.543-11.683-18.995-20.677-31.351-26.967 c-12.36-6.288-26.182-9.438-41.458-9.438c-34.61,0-61.126,13.92-79.553,41.75c-13.931,20.654-20.894,53.084-20.894,97.291 c0,54.769,8.309,92.31,24.941,112.619c16.627,20.309,39.998,30.469,70.113,30.469c29.212,0,51.284-8.209,66.231-24.605 C344.93,355.891,355.773,332.066,362.517,300.83z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgC);
export default __webpack_public_path__ + "static/media/c.760b52511d640b6cf87ecccf18d586c1.svg";
export { ForwardRef as ReactComponent };